'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".TextLink-module_textLink__cMa5a{border:0;color:#2b7cac;font-size:.875rem;line-height:1.25rem;padding:0}.TextLink-module_textLink__cMa5a,.TextLink-module_textLink__cMa5a:hover{background:transparent;-webkit-text-decoration:underline;text-decoration:underline}.TextLink-module_textLink__cMa5a:hover{color:\"inherit\";cursor:pointer}";
var styles = {"textLink":"TextLink-module_textLink__cMa5a"};
styleInject["default"](css_248z, '61de081c-adbb-4c74-bf53-a0e27e9958c6');

exports["default"] = styles;
